export const quiz = {
    topic: 'Will you be my Valentine?',
    level: 'Yes or No?',
    totalQuestions: 4,
    perQuestionScore: 5,
    questions: [
      {
        question: 'What is my nickname in primary school?',
        choices: ['damjep', 'Gengster Burger', 'Adam Jeffery', 'Botak'],
        type: 'MCQs',
        correctAnswer: 'Gengster Burger',
      },
      {
        question: 'What is the iconic date kita pernah buat (Adams opinion)?',
        choices: ['Trafalgar Square', 'Museum', 'Portugal', 'Cambridge Tour'],
        type: 'MCQs',
        correctAnswer: 'Portugal',
      },
      {
        question:
          'Why do you think I love you',
        choices: ['Sangat sangat cantik', 'Very the manja', 'Busuk', 'Sangat independent'],
        type: 'MCQs',
        correctAnswer: 'Busuk',
      },
      {
        question: 'What is the food that we both like ?',
        choices: ['Sushi', 'Kucing', 'Malay Food', 'Ayam'],
        type: 'MCQs',
        correctAnswer: 'Kucing',
      },
    ],
}